import React, { ReactNode, useEffect } from 'react';
import { CaslPermission, hasPermissions } from 'config/ability';
import { useAuthContext } from 'context/auth.context';
import Loading from 'components/Messages/Loading/Loading';

interface PermissionCheckProps {
  permission?: CaslPermission;
  children?: ReactNode;
}

type Props = PermissionCheckProps;

const PermissionCheck = ({ permission, children }: Props): JSX.Element => {
  const { ability, permissionsLoaded } = useAuthContext();

  if (permission) {
    if (permissionsLoaded) {
      return (
        <>
          {hasPermissions(ability, permission.action, permission.subject, permission?.conditions) &&
            children}
        </>
      );
    }

    return <Loading />;
  }

  return <>{children}</>;
};

export default PermissionCheck;
